<template>
    <el-dialog width="520px" title="切换分组" :before-close="handleClickCancel" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="groupingSwitchVisible" append-to-body>
        <div class="details">
            <el-form size="small" ref="generalForm"   v-loading="loading"
                     label-position="top" :model="generalForm"  :rules="generalFormRules">
                <el-form-item label="选择分组" prop="name">
                    <el-popover placement="bottom" trigger="click" v-model="popoverShow" width="472">
                        <el-select :popper-append-to-body="false" class="selectTree" placeholder="请选择分组" readonly slot="reference"  v-model="generalForm.name"></el-select>
                        <div class="tree_wrap">
                            <el-tree :check-on-click-node="true"
                                     :check-strictly="true"
                                     :data="categoryDataList"
                                     :default-expand-all="true"
                                     :expand-on-click-node='false'
                                     :props="{children: 'children',label: 'name'}"
                                     @node-click="handleSelectNode"
                                     node-key="id"
                                     ref="selectTree"
                                     size="mini">
                            </el-tree>
                        </div>
                    </el-popover>

                    <span class="handle_icon_wrap" @click="groupingVisible = true">
                        <i class="iconfont icon-a-tianjiamiaobian"></i>
                    </span>
                </el-form-item>

            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
        <groupingTemplate :groupingVisible.sync="groupingVisible" v-if="groupingVisible"  @success="getCategoryData()"/>

    </el-dialog>
</template>
<script>
import {GoodsCategoryList} from '@/api'
import groupingTemplate from "./groupingTemplate.vue";
import batchTransfer from "./batch_transfer";
import ordinaryEdit from "./ordinary_edit";
import standardEdit from "./standard_edit";
import combinationEdit from "./combination_edit";
export default {
    name: 'grouping_switch',
    components: {
        groupingTemplate,
    },
    props: {
        groupingSwitchVisible: {
            type: Boolean,
            default: false,
        },
        groupingId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            generalForm:{
                id:'',
                name:''
            },
            generalFormRules:{
                name:[{ required: true, message: '请选择分组', trigger: 'blue'}],
            },
            categoryDataList:[],
            popoverShow:false,
            groupingVisible:false,
        }
    },
    created() {
        this.getCategoryData()
    },
    computed: {

    },
    mounted() {

    },
    methods: {

        handleSelectNode(data, node, nodeData){
            this.generalForm.id = data.id;
            this.generalForm.name = data.name;
            this.popoverShow = false
        },
        getCategoryData(){
            this.loading = true
            GoodsCategoryList({}).then(res => {
                if (res.code === 200) {
                    this.categoryDataList = res.data
                }
                this.loading = false
            })
        },

        handleClickConfirm(){
            this.$refs.generalForm.validate(valid => {
                if (valid) {
                    this.$emit('success',this.generalForm)
                    this.$emit('update:groupingSwitchVisible', false)
                }
            })
        },


        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:groupingSwitchVisible', false)
        },


    },

}
</script>
<style lang="scss" scoped>
.selectTree{
    width: 100%;
    ::v-deep .el-select-dropdown{
        display: none !important;
    }
    ::v-deep .el-input__suffix{
        display: none;
    }
}

.handle_icon_wrap{
    position: absolute;
    right: 12px;
    top: 5px;
    color: rgba(102, 102, 102, 1);
}
</style>
